import { Component, OnInit, Input, SimpleChanges, Renderer2, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { Product } from 'src/app/models/class/product';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MediaObserver } from '@angular/flex-layout';
import { ProdComponent } from 'src/app/components/dialogs/prod/prod.component';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import { FulleStockService } from 'src/app/services/api/fulle/fulle-stock/fulle-stock.service';
import { ProdcatService } from 'src/app/services/api/prodcat/prodcat.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ProductService } from 'src/app/services/api/product/product.service';
import { CssService } from "../../../../services/css-service";
import { SalemethodService } from "../../../../services/api/salemethod/salemethod.service";

@Component({
  selector: 'app-basket-product',
  templateUrl: './basket-product.component.html',
  styleUrls: ['./basket-product.component.css']
})
export class BasketProductComponent implements OnInit, AfterViewInit {

  @Input() products$: any;
  @Input() categories$: any;
  @Input() activeButton: boolean | any;
  @Input() error: string | any;
  @Input() sideMode: string | any;
  @Input() orderDateHour: any;
  @Input() merchantClient$: any;
  @Input() webshop_visible: any;
  @Input() displayDay: any;
  @Input() displayHour: any;
  @Output() closeBasketEvent: EventEmitter<any> = new EventEmitter();
  @Output() outPutSubmitOrder: EventEmitter<any> = new EventEmitter();
  @Output() openSmDial: EventEmitter<any> = new EventEmitter();
  @Output() openSelectProductsTimeSlotDialEvent: EventEmitter<any> = new EventEmitter();

  panier$: Product[] | any = [];

  default_prod: string = "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";

  currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);

  currAddress: any;

  totalQuantPan: number | any;
  totalPricePan: number | any;
  totalWeightPan: number | any;
  maxWeightPan: number | any;
  allTotal: number | any;

  numQuant: number[] = [];
  quantityChanged: any = null;

  panierheight1080: any;

  constructor(
    private panierMan: PanierService,
    public tools: ToolsService,
    private router: Router,
    public dialog: MatDialog,
    public cssService: CssService,
    public myDials: DialogsService,
    public media: MediaObserver,
    public renderer: Renderer2,
    private stockApi: FulleStockService,
    private prodcatApi: ProdcatService,
    public breakpointObserver: BreakpointObserver,
    public ProductService: ProductService
  ) {


    const layoutChanges = breakpointObserver.observe([
      '(orientation: portrait)',
      // '(orientation: landscape)',
    ]);

    layoutChanges.subscribe(result => {
      let borne = this.tools.getStor("devicePaybridge") ? this.tools.getStor("devicePaybridge") : null;
      let lt_lg = this.media.isActive("lt-lg");
      this.panierheight1080 = borne && lt_lg && result.matches && breakpointObserver.isMatched('(min-height: 1079px)') ? true : false;

    });
  }

  ngOnInit() {
    this.stockApi.displayAlertStockDialog(null, false).then(data => {
      this.panierMan.getPanier.subscribe(basket => {
        this.getInfoPan();
        this.panier$ = basket;
      });
    })
  }

  ngAfterViewInit(): void {

  }

  ngOnChanges(changes: SimpleChanges | any): void {


    if (changes.error && changes.error.currentValue) {
      if (changes.error.currentValue !== "emptypanier" && this.sideMode === "over") {
        this.closeBasket();
      }
    }
    if (changes && changes['merchantClient$']) {
      this.merchantClient$ = changes['merchantClient$'].currentValue;
      this.ngOnInit();
    }
    if (changes && changes['merchantClient$'] && changes['merchantClient$'].currentValue != changes['merchantClient$'].previousValue) {

      // this.ngOnInit();
    }


  }


  openProdDial(prod: any, from: string, index?: number) {


    //recupere les categories du produit api
    this.prodcatApi.getApiProdCatsByIdProd(prod).subscribe((cats) => {
      prod.categories = cats;
      this.openPreProdDial(prod, from, index);
    });


  }

  isMenuOptionCompatible(prod: any) {
    return prod.details && prod.details.length > 0 && prod.quantity == 1 && !prod.free
  }


  /**
   * @description Ouvre la popup de selection de produit
   * @param {any} prod
   * @param {string} from
   * @param {number} index
   */
  openPreProdDial(prod: any, from: string, index?: number) {


    const myConf = new MatDialogConfig();

    this.media.isActive("xs") ? myConf.panelClass = "full-screen" : myConf.width = (prod.product_type === 2) ? "780px" : "450px";

    myConf.autoFocus = false;
    myConf.data = {
      index: index,
      from: from,
      prod: prod,
      products: this.products$,
      // categories: this.categories$
      categories: prod.categories,

    };

    // this.ProductService.setObserProductTypeformule(prod.product_type == 2?true:false);
    // categories est dans le produits
    myConf.data.merchantClient = this.merchantClient$ ? this.merchantClient$ : null;
    const myDial = this.dialog.open(ProdComponent, myConf);


    myDial.afterClosed().subscribe((result) => {
    });
  }

  /**
   * @description Change la quantité d'un produit dans le panier
   * @param {number} i
   * @param {any} prod
   * @return {void}
   */
  updateQuantPan(i: number, prod: any): void {

    if (this.quantityChanged) {

      let stock = null;

      if (i >= 0) {
        stock = this.update_stock(prod);
      }

      prod.product_type < 2
        ? this.panierMan.manageProduct(prod, stock, i)
        : this.panierMan.manageProductFormule(prod, prod.details, stock, i);

    }

    this.quantityChanged = null;
  }

  /**
   * @description Ajoute de la quantité à un produit
   * @param {number} index
   * @param {any} prod
   */
  addProdQuant(index: number, prod: any) {
    const maxQuant = prod.quantities[prod.quantities.length - 1];
    if (prod.quantity + 1 <= maxQuant) {
      this.QtyStockChange(prod.quantity + 1, prod.quantity);
      prod.quantity += 1;
      this.updateQuantPan(index, prod);
    }
  }

  /**
   * @description Retire de la quantité à un produit
   * @param {number} index
   * @param {any} prod
   */
  removeProdQuant(index: number, prod: any) {
    const minQuant = prod.quantities[0];

    if (prod.quantity - 1 >= minQuant) {
      this.QtyStockChange(prod.quantity - 1, prod.quantity);
      prod.quantity -= 1;
      this.updateQuantPan(index, prod);
    }
  }

  /**
   * @description Change la quantité d'un produit et dans le stock
   * @param {any} prod
   */
  update_stock(prod: any) {

    if (prod.stock) {
      prod.stock.count = this.stockApi.handleProdStock(prod.id, this.quantityChanged, "remove", prod.stock.newcount);
    }

    if (prod.details) {

      prod.details.map((det: any) => {

        if (det.stock) {
          det.stock.count = this.stockApi.handleProdStock(det.id, this.quantityChanged, "remove", det.stock.newcount);
        }
      })
    }

    return this.stockApi.stocks;
  }

  /**
   * @description Récupère toutes les infos du panier
   * @returns {void}
   */
  getInfoPan(): void {
    this.totalQuantPan = this.panierMan.getQuant();

    this.totalPricePan = this.merchantClient$ && this.merchantClient$.id_group && (this.merchantClient$.discount || this.merchantClient$.groups_discount) ?
      this.panierMan.getTotalAfterDiscount(this.merchantClient$) : this.panierMan.getPrice();


    this.totalWeightPan = this.panierMan.getWeight();
    this.allTotal = this.panierMan.getPanInfos("allship");
  }

  /**
   * @description calcul l'ecart entre ancienne et nouvelle qté stock
   * @param {number} newQty
   * @param {number} oldQty
   */
  QtyStockChange(newQty: number, oldQty: number) {
    this.quantityChanged = newQty - oldQty;
  }


  /**
   * @description Retire un produit du panier
   * @param {number} index
   * @param {any} prod
   * @return {void}
   */
  removeProdPan(index: number, prod: any): void {


    this.panierMan.removeProduct(index);


    //formule
    // prod.categories && prod.categories.length > 0 &&
    if (prod.product_type == 2) {
      //change le stock

      this.changeStock(prod);
      this.panierMan.setCurrentBasket(prod, "delete");

    } else if (prod.stock) {

      // produit
      this.stockApi.handleProdStock(prod.id, prod.quantity, "add", prod.stock.newcount);
      this.panierMan.setCurrentBasket(prod, "delete");
    }


    this.getInfoPan();

    if (this.panier$ && this.panier$.length < 1 && !this.tools.checkCurrentPage('Endorder')) {
      this.closeBasket();
    }

  }

  /**
   * @description on change le stock lors d'une suppression d'une formule qui à un produit avec du stock
   * @param {any} prod
   * @return {void}
   */
  changeStock(prod: any): void {


    if (prod.stock) {
      this.stockApi.handleProdStock(prod.id, prod.quantity * prod.quantity, "add", prod.stock.newcount);
    }
    if (prod.details.length > 0)
      for (let i = 0; i < prod.details.length; i++) {
        let item = prod.details[i];
        if (item.stock) {
          this.stockApi.handleProdStock(item.id, item.quantity * prod.quantity, "add", item.stock.newcount);
        }
      }

  }

  /**
   * @description Redirige vers la page de fin de commande, bouton paiement du ProductComponent
   * @return {void}
   */
  goEndOrder(): void {

    // Montant minimum de commande
    if (this.totalPricePan < this.currSm.minimum_order) {
      this.myDials.openMiniAmountDial();
      return;
    }

    // URL Nepting
    //TODO voir pour mieux stocker cela
    this.tools.setStor("neptingweblocation", window.location.origin);

    this.stockApi.displayAlertStockDialog(null, true).then(
      result => {
        // On peut passer à l'interface de paiement
        if (result.data) {
          this.router.navigate(["/endorder"]);
        }
      })
  }

  submitOrder($ev?: any) {
    this.outPutSubmitOrder.emit(true);
  }

  closeBasket($ev?: any) {
    this.closeBasketEvent.emit();
  }

  /**
   * @description Ouvre la popup de selection de methode de vente
   */
  openDialSm(): void {
    this.openSmDial.emit(this.currSm.id);
  }

  /**
   * @description Ouvre la popup de selection de créneaux horaire
   */
  openSelectProductsTimeSlotDial($ev?: any) {
    this.openSelectProductsTimeSlotDialEvent.emit();
  }

  isEmptyBasket() {
    return this.panier$ && this.panier$.length == 0
  }

  hasDeliveryOrShippingCost() {
    return this.currSm.enable_shipping_cost > 0 || this.currSm.enable_delivery > 0
  }

  truncatedText(text: string): string {
    return text.length > 20 ? text.slice(0, 20) + '…' : text;
  }

  getSubTotalItemLine(item: any): number {
    // Calcule le total pour l'élément courant
    let total = item.price * item.quantity;

    // Vérifie si l'élément a des sous-détails et les traite récursivement
    if (item.details && item.details.length > 0) {
      for (const subDetail of item.details) {
        total += this.getSubTotalItemLine(subDetail);
      }
    }

    return total;
  }

  getSubItemNames(item: any): string {
    // Initialise un tableau pour stocker les noms
    const names: string[] = [];

    // Fonction interne récursive pour parcourir les éléments
    function collectNames(currentItem: any) {
      names.push(currentItem.name);
      if (currentItem.details && currentItem.details.length > 0) {
        for (const subDetail of currentItem.details) {
          collectNames(subDetail);
        }
      }
    }

    // Démarre la récursion avec l'élément principal
    collectNames(item);

    // Concatène les noms avec une virgule et un espace
    return names.join(', ');
  }
}
